<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex justify-between items-center">
      <div class="flex items-center">
        <div class="mr-2" @click="handleClick('admin-playlist')">
          <feather-icon
            icon="ChevronLeftIcon"
            svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
            class=""
          ></feather-icon>
        </div>
        <h2 class="text-2xl font-semibold mt-4 mb-4">List of Episodes</h2>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleAdd()"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon>
          Add Episode
        </span>
      </base-button>
    </div>
    <EpisodeTable />
  </b-card>
</template>

<script>
import EpisodeTable from "./components/episodeTable.vue";
export default {
  components: {
    EpisodeTable,
  },
  methods: {
    handleClick(val) {
      this.$router.push({ name: val });
    },
    handleAdd() {
      this.$router.push({
        name: "add-episode",
        query: {
          pid: this.$route.query.pid,
          cid: this.$route.query.cid,
        },
      });
    },
  },
};
</script>
<style></style>
